/**
 * Used to store session log enum values with their respective functions
 */
export enum SessionLogsEnum {
    CHECK_OUT = 1,
    CHECK_IN = 2,
    RENEW = 3,
    TAGGING = 4,
    PATRON_TAGGING = 5,
    BIOMETRIC_REGISTERATION = 6
}